import {  defaultProviders } from "@energylab/shared-components/constants/config/providersConfig";

export const providers = [
    ...defaultProviders,
    "hardlopenmetevy"
];
